// Invoice / ETS lock messages. The backend now returns:
//  - `error_code` on failed updateInvoice / createETS / updateETS / deleteETS
//    (e.g. a partner invoice ETS change -> 403 PARTNER_INVOICE_SCHEDULE_LOCKED);
//  - `lock_reasons` (a field -> code map) on a successful updateInvoice, telling
//    the FE which fields are managed by the ETS / the source software.
// Both use the same reason codes below. French is the source string; Weglot
// translates it to the other locales.
export const INVOICE_LOCK_MESSAGES = {
  MULTI_ETS_STATUS_LOCKED: {
    fr: 'Le statut est déterminé par les échéances',
    en: 'The status is determined by the schedule',
  },
  MULTI_ETS_AMOUNT_LOCKED: {
    fr: 'Le montant est la somme des échéances',
    en: 'The amount is the sum of the schedule',
  },
  MULTI_ETS_DATE_LOCKED: {
    fr: 'Les dates sont reprises des échéances',
    en: 'The dates are taken from the schedule',
  },
  MULTI_ETS_PAYMENT_TERMS_LOCKED: {
    fr: 'Le délai de paiement est porté par les échéances',
    en: 'The payment terms are carried by the schedule',
  },
  PARTNER_INVOICE_LOCKED: {
    fr: "Cette facture est modifiable dans le logiciel d'origine",
    en: 'This invoice is editable in the source software',
  },
  PARTNER_INVOICE_SCHEDULE_LOCKED: {
    fr: "Les échéances sont gérées par le logiciel d'origine",
    en: 'The schedule is managed by the source software',
  },
  PLUG_INVOICE_LOCKED: {
    fr: 'Cette ligne est un rapprochement automatique (crédit non affecté)',
    en: 'This line is an automatic reconciliation entry (unallocated credit)',
  },
};

// Suggestions de rapprochement ETS <-> transaction (TT-7250). Une suggestion
// « périmée » n'est pas une vraie erreur : la file a bougé (traitée ailleurs, ou
// l'ETS a changé), la ligne doit juste disparaître.
export const ETS_SUGGESTION_MESSAGES = {
  SUGGESTION_ALREADY_RESOLVED: {
    fr: 'Cette suggestion a déjà été traitée',
    en: 'This suggestion has already been handled',
  },
  SUGGESTION_STALE: {
    fr: "Cette suggestion n'est plus valide : la liste a été actualisée",
    en: 'This suggestion is no longer valid: the list has been refreshed',
  },
};

export function isInvoiceApi(api) {
  return (
    typeof api === 'string' &&
    [
      'updateInvoice',
      'createETS',
      'updateETS',
      'deleteETS',
      'validateETSTransactionSuggestion',
      'rejectETSTransactionSuggestion',
    ].includes(api)
  );
}

// Map a single lock/reason code to its localized message (used both by the
// error resolver below and by the lock_reasons notification after a save).
export function invoiceLockMessage(code, locale = 'fr') {
  const normalizedLocale = locale === 'en' ? 'en' : 'fr';
  return INVOICE_LOCK_MESSAGES[code]?.[normalizedLocale] || null;
}

export function resolveInvoiceErrorMessage({error, locale = 'fr'} = {}) {
  const code = error?.error_code || error?.code || error?.errorCode;
  if (!code) return null;
  const normalizedLocale = locale === 'en' ? 'en' : 'fr';
  return (
    invoiceLockMessage(code, locale) ||
    ETS_SUGGESTION_MESSAGES[code]?.[normalizedLocale] ||
    null
  );
}
